export default {
  // 预览合同协议
  contractPreview: {
    url: '/mp/order/contract/preView',
    method: 'GET'
  }
};
